import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {v4 as uuid} from 'uuid'

function TableauModalEdit({titre, setIsOpen, IsOpen, modalContext, fields, actionEdit, actionDelete, setUpdateView}) {

  const dispatch = useDispatch()
  const [values, setValues] = useState(modalContext)

  useEffect(()=>{
    setValues(modalContext)

  },[modalContext])

  if(!IsOpen){
    return null
  }

  const onClose = () => {
    setIsOpen(false)
  }
  const modificationHandler = (field, value) => {
    let temp_val = value.value

    if(field.type ==='checkbox') {
      temp_val = value.checked
    }
    setValues((prev) => ({
      ...prev,
      [field.name]: temp_val,
    }));

  };

  const handleSave = () => {
    dispatch(actionEdit(values));
    setUpdateView(true);
    onClose();
  }

  const handleDelete = () => {
    dispatch(actionDelete(values));
    setUpdateView(true);
    onClose();

  }

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50'>
      <div className="bg-white rounded-xl p-6 min-w-96 w-2/4 shadow-lg">
      <h3 className='text-2xl font-bold mb-4 underline'>Modification des données <span className='uppercase'>{titre}</span> </h3>
      <div className='flex flex-col gap-3 mb-10'>
        {fields.map(field => !field.allowUpdating  ||
          (
          <div key={uuid()} className='flex flex-col justify-start mb-3'>
            <label key={uuid()} for={field.name}
            className="block mb-2 text-xl font-medium text-orange-900 uppercase">{field.name} :</label>
            <input key={uuid()}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full p-2.5"
            id={field.name}
            name={field.name}
            value={values[field.name] || "" }
            checked={values[field.name]}
            type={field.type}
            onChange={(e) => modificationHandler(field, e.target)}
          />
          </div>

        )
        )}
      </div>
      <div className="flex flex-row justify-end items-end">
        <button className='mx-2 py-2 px-8 font-bold text-md shadow-lg shadow-gray-500 text-white rounded-lg bg-green-600 hover:bg-green-800' onClick={handleSave}>Valider</button>
        <button className='mx-2 py-2 px-8 font-bold text-md shadow-lg shadow-gray-500  text-white rounded-lg bg-orange-600 hover:bg-orange-800' onClick={handleDelete}>Supprimer</button>
        <button className='mx-2 py-2 px-8 font-bold text-md shadow-lg shadow-gray-500  text-white rounded-lg bg-red-600 hover:bg-red-800'onClick={onClose}>Annuler</button>
      </div>
      </div>
    </div>
  )
}

export default TableauModalEdit;